import React , { useRef, useState} from 'react';
import { navigate } from 'gatsby';
import {ckeckStatus,sendOTP,verifyOTP} from "../../../service/accountService";
import {getCartItems,getCartInfo} from '../../../service/cartService';
import {Format2Degits} from "../../../utils/format";
import { useTimer } from 'react-timer-hook';
import Layout from "../../../components/mobile/Layout/layoutmobileempty";
import { toast } from 'react-toastify';

import "./css/logins.css"
function Login(props) {
  const time = new Date(); 
  const {
    seconds,
    minutes,
    restart,
  } = useTimer({ time, onExpire: () => console.warn('onExpire called') });
  const renderButtonOTP = (seconds, minutes ,status) => {
    if (seconds === 0 && minutes === 0 && status === true) {
      return <button type="submit" className="btn btn-primary-mb text_12 font_700" onClick={handleSendOTP}>Gửi OTP</button>;
    } else if (((seconds !== 0 && minutes === 0) || (seconds !== 0 && minutes !== 0)) && status === true){
      return <div className="countdown">{Format2Degits(minutes)}:{Format2Degits(seconds)}</div>;
    }else {
      return (null)
    }
  }

  const [status,setStatus] = useState(false);
  const renderInputOTP = (status) =>{
    if (status === true) {
      return <div className='pdx-0 mgt-10'><span className='login-nav-textnum-mb col-12 mgt-10'>Mã xác thực <span className='color_red'>*</span></span>
      <div className="login-futter-mb col-12 mgt-10">
        <input className="confirm-input-mb" type="number" id="" name="otp" placeholder="Nhập mã OTP vừa gửi đến điện thoại của Bạn"/>
      </div>
      </div>;
    } 
  }
  const [show,setShow] = useState(true);
  const regexPhoneNumber = new RegExp(/(84|0[3|5|7|8|9])+([0-9]{8})\b/g);
  const [phone, setText] = useState(null);
  const renderButtonSubmit = (_phone) =>{

    if (status === false) {
      // return <button className="button-login-mb" onClick={handleSendOTP}>Gửi OTP</button>;
      setShow(true);
    } 
  };

  const inputChange = (e) =>{
    setText(e.target.value); 
    if (regexPhoneNumber.test(phone) === false) {
      setStatus(false);
      setShow(true);
      const time = new Date();
      time.setSeconds(time.getSeconds());
      restart(time)
    } 
  }

  let handleSubmit = async (e) => {
    console.log(2)
    e.preventDefault();
    const data = new FormData(e.target);
    let _phone = data.get('phone');
    let opt = data.get('otp');
    try{

      verifyOTP({
        phone:_phone,
        code: opt,
        type:1
      }).then((response)=>{
        if(response.status === 200){
          window.localStorage.setItem('key', response["message"]?.accessToken);
          window.localStorage.setItem('phone', response["message"]?.user?.phone);
          window.localStorage.setItem('memberCard', response["message"]?.user?.memberCard);
          window.localStorage.setItem('name', response["message"]?.user?.name);
          window.localStorage.setItem('_id', response["message"]?.user?._id);
        if(response["message"]?.accessToken  && response["message"]?.accessToken !== '' && response["message"]?.accessToken !== undefined && response["message"]?.accessToken !== null){
          toast.success('Đăng nhập thành công.');
          
          window.localStorage.setItem('userReferral', '');
          window.localStorage.setItem('idShare', '');

          setTimeout(async () =>{
           await getCartInfo(response["message"]?.accessToken).then((response)=>{
              window.localStorage.setItem('cartInfo', JSON.stringify(response['message']));
              
              let _cartInfo = response['message'];
              if(_cartInfo !== null){
                  window.localStorage.setItem('bixu', _cartInfo[0]?.owner?.bixu);
              }else{
                window.localStorage.setItem('bixu', 0);
              }

            });
            await getCartItems(response["message"]?.accessToken).then((response)=>{
              console.log(response['message']);
              localStorage.setItem('itemsCart', JSON.stringify(response['message']));
            });

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                    'event': 'login',
                    'user_id': response["message"]?.user?._id,
                    'eventCallback': function() {
                    }
                });
                
            if(window.localStorage.getItem('urlBack') !== '' && window.localStorage.getItem('urlBack') !== undefined && window.localStorage.getItem('urlBack') !== null){
              window.location.href = window.localStorage.getItem('urlBack');
              window.localStorage.setItem('urlBack', '');
            }
            else{
              // window.history.back();
              window.location.href = '/';
            }
          } , 1000);
        }else{
          toast.warning('Không thể đăng nhập được. Vui lòng kiểm tra lại đường truyền mạng.');
        }
        }else{
          toast.warning('Không thể đăng nhập được. Vui lòng kiểm tra thông tin tài khoản.');
        }
      });
     
    }catch(e){
      console.log(e);
    }
  }

  const phoneRef = useRef(null);
  let handleSendOTP = async (e)=>{
      
      e.preventDefault();
      e.target.disabled = true;
      let _phone = phoneRef.current.value;
      if(_phone === ''){
        toast.error("Ba/Mẹ vui lòng nhập số điện thoại hợp lệ để tiếp tục.");
        e.target.disabled =false
      }else{
          try{
            ckeckStatus({phone:_phone}).then((response) => {
              let status = response["status"];
              if(status === 200){
                sendOTP({
                  phone:_phone,
                  type:1
                }).then((response)=>{
                  console.log(response["status"]);
                })
                setStatus(true);
                setShow(false);
                e.target.disabled =false;
              }else{
                toast.error(response["message"]);
                e.target.disabled =false;
              }
          }); 

            const time = new Date();
            time.setSeconds(time.getSeconds() + 180);
            restart(time)
            // setTimeout(() =>{e.target.disabled =false} , 180000);
        }catch(e){
          console.log(e);
        } 
      }
  }
  const handleClick=(uri)=>{
    navigate(uri);
} 
const handleBack = () => {
  window.history.back();
}

    return (
      <Layout>
        <div className="container1">
        <div className="header1 flex-col-nowrap">
        <div className="row mgt-10">
                <div onClick={()=>handleBack()} className="col-2 in-f">
                    <img src="/../images/voucher/ic_back.svg" alt="icon"/>
                </div>
                <div className="col-8 in-f">
                    <strong className="text_header color_gray">TÀI KHOẢN</strong>
                </div>
                <div className="col-2 in-f">
                  <a onClick={()=>handleClick('/')}>
                    <img src="/../images/account/home.svg" alt="icon"/>
                  </a>
                </div>
            </div>
            <div className="row mgt-10">
                <div className="col-12 text-center">
                    <div className="position-relative">
                        <img src="/../images/account/banner.png" alt="icon"/>
                    </div>
                    <span className="position-absolute banner_custom">
                        <img className="position-relative top-0" src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/account_user.png" alt="icon"/>
                    </span>
                    <span className="position-absolute logo_custom">
                        <img className="position-relative top-0" src="/../images/account/logo_bibo-05.png" alt="icon"/>
                    </span>
                </div>
            </div>
            <div className="row mgt-30">
                <div className="col-12 text-center mgt-10">
                    <strong className="text_dn">Đăng nhập</strong>
                </div>
            </div>
        <form className='form-login-mb mgx-0' onSubmit={handleSubmit}>
        <div className='row mgt-10 mgx-0 pdx-30 bg-index pdy-24'>
            <div className='col-12 pdx-0'>

                <div className='row mgx-0'>
                  <span className='login-nav-textnum-mb col-12 pdx-0'>Số điện thoại <span className='color_red'>*</span></span>
                  <div className="login-futter-mb col-12 mgt-10">
                  <input className="login-input-mb error" type="" required ref={phoneRef} onKeyDown={(e) => inputChange(e)} name="phone" placeholder="Nhập số điện thoại"/>
                    {renderButtonOTP(seconds, minutes ,status)}
                    {/* <button type="submit" className="btn btn-primary-mb text_12 font_700" disabled>{Format2Degits(minutes)}:{Format2Degits(seconds)}</button> */}
                  </div>
                  
                  {renderInputOTP(status)}
                </div>
                <div className="check-confirm pdt-20">
                  <div className="">
                    <input className="form-check-input" type="checkbox" name="current" id="flexCheckDefault" defaultChecked/>
                    <label className="form-check-label" htmlFor="flexCheckDefault">
                    </label>
                  </div>
                  <span>Tôi đã đọc và đồng ý với các <a onClick={()=>handleClick('/bao-mat-thong-tin-ca-nhan.html')}>Điều khoản sử dụng</a> và 
                  <a onClick={()=>handleClick('/su-dung-thong-tin.html')}> Chính sách bảo mật</a> của Bibo Mart</span>
                </div>
                <div className='login-foot-mb col-12 mgt-10 pdb-10'>
                  <div className="login-button-mb">
                    {/* {renderButtonSubmit(phone)} */}
                    {
                      show === true ? (
                        <button type="submit" className="button-login-mb" onClick={handleSendOTP}>Gửi OTP</button>
                      ):(
                        <button type="submit" id="button-login-mb" className="button-login-mb">Đăng nhập</button> 
                      )
                    }
                      {/* <button className="button-login-mb">Đăng nhập</button>  */}
                    {/* <button className="button-login-mb" onClick={show === true ? handleSendOTP() : (null)}>{show === true ? "Gửi OTP" : "Đăng nhập"}</button> */}
                  </div>
                </div>
            </div>
        </div>
        </form>
        </div>
        </div>
      </Layout>
    )
}
export default Login;